import { useCallback, useEffect, useState } from 'react';
import {
  alternarOculta,
  carregarSecoes,
  definirPadrao,
  moverSecao,
  salvarSecoes,
} from '@/conversas/secoesInbox';

/**
 * As preferências de seção da pessoa, carregadas do disco e gravadas a cada
 * mudança.
 *
 * Sem `ref` para o valor corrente — ao contrário do `useNotificacaoSom`. Lá o
 * efeito de detecção precisava ler as preferências SEM depender delas; aqui
 * todo consumo acontece na renderização, então o estado basta e a lista reflete
 * a edição na hora.
 */
export function useSecoesInbox(uid) {
  const [preferencias, setPreferencias] = useState(() => carregarSecoes(uid));

  // Troca de pessoa recarrega: o computador da recepção é compartilhado.
  useEffect(() => {
    setPreferencias(carregarSecoes(uid));
  }, [uid]);

  const aplicar = useCallback(
    (proximas) => {
      setPreferencias(proximas);
      // Falha de gravação não vira erro na tela: a escolha vale para esta
      // sessão de qualquer forma.
      salvarSecoes(uid, proximas);
    },
    [uid],
  );

  /**
   * As três ações devolvem as preferências INTACTAS quando a operação é
   * inválida (mover a primeira para cima, ocultar a padrão). Regravar o mesmo
   * valor é inofensivo, e a alternativa — cada ação decidir se vale a pena
   * chamar — espalharia as guardas pela tela.
   */
  return {
    preferencias,
    mover: useCallback((id, direcao) => aplicar(moverSecao(preferencias, id, direcao)), [aplicar, preferencias]),
    alternarVisibilidade: useCallback((id) => aplicar(alternarOculta(preferencias, id)), [aplicar, preferencias]),
    tornarPadrao: useCallback((id) => aplicar(definirPadrao(preferencias, id)), [aplicar, preferencias]),
  };
}
